import {
  CLEAR_LIST_VIDEO_LIBRARY,
  CREATE_VIDEO,
  CREATE_VIDEO_CLEAR,
  CREATE_VIDEO_ERROR,
  CREATE_VIDEO_SUCCESS,
  EXPORT_VIDEO_LIBRARY_REPORT,
  EXPORT_VIDEO_LIBRARY_REPORT_ERROR,
  EXPORT_VIDEO_LIBRARY_REPORT_SUCCESS,
  GET_LIST_VIDEO_LIBRARY,
  GET_LIST_VIDEO_LIBRARY_ERROR,
  GET_LIST_VIDEO_LIBRARY_SUCCESS,
  GET_VIDEO,
  GET_VIDEO_CLEAR,
  GET_VIDEO_ERROR,
  GET_VIDEO_SUCCESS,
  REMOVE_VIDEO,
  REMOVE_VIDEO_CLEAR,
  REMOVE_VIDEO_ERROR,
  REMOVE_VIDEO_SUCCESS,
  UPDATE_VIDEO,
  UPDATE_VIDEO_CLEAR,
  UPDATE_VIDEO_ERROR,
  UPDATE_VIDEO_SUCCESS,
} from "./actionTypes";

export const getListVideoLibrary = (payload) => {
  return {
    payload,
    type: GET_LIST_VIDEO_LIBRARY,
  };
};
export const getListVideoLibrarySuccess = ({ data, pagination }) => {
  return {
    payload: { data, pagination },
    type: GET_LIST_VIDEO_LIBRARY_SUCCESS,
  };
};
export const getListVideoLibraryError = ({ message }) => {
  return {
    payload: { message },
    type: GET_LIST_VIDEO_LIBRARY_ERROR,
  };
};
export const clearListVideoLibrary = () => ({
  type: CLEAR_LIST_VIDEO_LIBRARY,
});

export const getVideo = (fileId) => {
  return {
    payload: { fileId },
    type: GET_VIDEO,
  };
};

export const getVideoSuccess = ({ data }) => {
  return {
    payload: data,
    type: GET_VIDEO_SUCCESS,
  };
};

export const getVideoError = ({ message = "Unknown error" }) => {
  return {
    payload: { message },
    type: GET_VIDEO_ERROR,
  };
};

export const clearVideoFetched = () => {
  return {
    type: GET_VIDEO_CLEAR,
  };
};

export const createVideo = (data, history) => {
  return {
    payload: { data, history },
    type: CREATE_VIDEO,
  };
};

export const createVideoSuccess = ({ data }) => {
  return {
    payload: data,
    type: CREATE_VIDEO_SUCCESS,
  };
};

export const createVideoError = ({ message = "Unknown error" }) => {
  return {
    payload: { message },
    type: CREATE_VIDEO_ERROR,
  };
};

export const clearVideoLibraryCreated = () => {
  return {
    type: CREATE_VIDEO_CLEAR,
  };
};

export const clearVideoLibraryRemoved = () => {
  return {
    // type: REMOVE_BUNDLE_CLEAR,
  };
};

export const updateVideo = (data, history) => {
  return {
    payload: { data, history },
    type: UPDATE_VIDEO,
  };
};

export const updateVideoSuccess = ({ data }) => {
  return {
    payload: data,
    type: UPDATE_VIDEO_SUCCESS,
  };
};

export const updateVideoError = ({ message = "Unknown error" }) => {
  return {
    payload: { message },
    type: UPDATE_VIDEO_ERROR,
  };
};

export const clearVideoLibraryUpdated = () => {
  return {
    type: UPDATE_VIDEO_CLEAR,
  };
};

export const changeVideoLibraryStatusClear = () => {
  return {
    // type: CHANGE_BUNDLE_STATUS_CLEAR,
  };
};

export const removeVideo = (data, history) => {
  return {
    payload: { data, history },
    type: REMOVE_VIDEO,
  };
};

export const removeVideoSuccess = ({ data }) => {
  return {
    payload: data,
    type: REMOVE_VIDEO_SUCCESS,
  };
};

export const removeVideoError = ({ message = "Unknown error" }) => {
  return {
    payload: { message },
    type: REMOVE_VIDEO_ERROR,
  };
};

export const clearVideoRemoved = () => {
  return {
    type: REMOVE_VIDEO_CLEAR,
  };
};

export const exportVideoLibraryReport = () => {
  return {
    // payload: { data, history },
    type: EXPORT_VIDEO_LIBRARY_REPORT,
  };
};

export const exportVideoLibraryReportSuccess = ({ data }) => {
  return {
    payload: data,
    type: EXPORT_VIDEO_LIBRARY_REPORT_SUCCESS,
  };
};

export const exportVideoLibraryReportError = ({ message = "Unknown error" }) => {
  return {
    payload: { message },
    type: EXPORT_VIDEO_LIBRARY_REPORT_ERROR,
  };
};